import {rqCreateRequest, rqCreateSearchRequest} from './rqHttpsUtils';
import {useQuery} from '@tanstack/react-query';
import {
  RQ_APPROVE_REJECT_CUSTOMER_CAMPAIGN_ENROLLMENT,
  RQ_CUSTOMER_CAMPAIGN_ENROLL, RQ_EXTEND_CUSTOMER_CAMPAIGN_ENROLL, RQ_EXTEND_SINGLE_CUSTOMER_CAMPAIGN_ENROLL,
  RQ_GET_ENROLLMENT_BY_ID,
  RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLL,
  RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT,
  RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT_DOCUMENTS,
  RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT_DOCUMENTS_LIST,
  RQ_SEARCH_CUSTOMER_CAMPAIGN_MASTER, RQ_UPDATE_CUSTOMER_CAMPAIGN_ENROLL,
} from './constants/rqCustomerCampaignEnrollAPIConstants';

export const RQGetCustomerCampaignEnrollDocuments = (payload, options={}) => {
  return useQuery({
    queryKey: ['rq_get_customer_campaign_enroll_documents', payload],
    queryFn: async ({queryKey, signal}) => {
      const {params, token} = queryKey[1];
      return rqCreateRequest(
        RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT_DOCUMENTS,
        null,
        token,
        params,
        signal,
        null,
      );
    },
    ...options,
  });
};

export const RQGetCustomerCampaignEnrollDocumentList = (payload, options={}) => {
  return useQuery({
    queryKey: ['rq_search_customer_campaign_enrollment_documents_list', payload],
    queryFn: async ({queryKey, signal}) => {
      const {params, token} = queryKey[1];
      return rqCreateRequest(
        RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT_DOCUMENTS_LIST,
        null,
        token,
        params,
        signal,
        null,
      );
    },
    ...options,
  });
};

export const RQGetCustomerCampaignEnroll = (payload, options={}) => {
  return useQuery({
    queryKey: ['rq_get_customer_campaign_enroll', payload],
    queryFn: async ({queryKey, signal}) => {
      const {filter, token} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLL,
        null,
        token,
        null,
        signal,
        filter,
      );
    },
    ...options,
  });
};

export const RQSubmitCustomerEnrollmentAPI = ({data, token, signal}) => {
  return rqCreateRequest(
    RQ_CUSTOMER_CAMPAIGN_ENROLL,
    JSON.stringify(data),
    token,
    null,
    signal,
  );
};

export const RQUpdateCustomerEnrollmentAPI = ({data, token, signal}) => {
  return rqCreateRequest(
    RQ_UPDATE_CUSTOMER_CAMPAIGN_ENROLL,
    JSON.stringify(data),
    token,
    null,
    signal,
  );
};

export const RQApproveRejectEnrollmentAPI = ({params, token, signal}) => {
  console.log(params);
  return rqCreateRequest(
    RQ_APPROVE_REJECT_CUSTOMER_CAMPAIGN_ENROLLMENT,
    JSON.stringify({reason: params.reason}),
    token,
    params,
    signal,
  );
};

export const RQExtendEnrollmentAPI = ({params, token, signal}) => {
  return rqCreateRequest(
    RQ_EXTEND_CUSTOMER_CAMPAIGN_ENROLL,
    JSON.stringify({type: params.type, date: params.date}),
    token,
    params,
    signal,
  );
};

export const RQExtendSingleEnrollmentAPI = ({params, token, signal}) => {
  console.log(params);
  return rqCreateRequest(
    RQ_EXTEND_SINGLE_CUSTOMER_CAMPAIGN_ENROLL,
    JSON.stringify({type: params.type, date: params.date}),
    token,
    params,
    signal,
  );
};

export const RQGetCustomerCampaignEnrollments = (payload, options={}) => {
  return useQuery({
    queryKey: ['rq_get_customer_campaign_enrollments', payload],
    queryFn: async ({queryKey, signal}) => {
      const {filter, token} = queryKey[1];
      console.log(filter);
      return rqCreateSearchRequest(
        RQ_SEARCH_CUSTOMER_CAMPAIGN_ENROLLMENT,
        null,
        token,
        null,
        signal,
        filter,
      );
    },
    ...options,
  });
};

export const RQGetCustomerCampaignEnrollmentById = (payload, options={}) => {
  return useQuery({
    queryKey: ['rq_get_customer_campaign_enrollment_by_id', payload],
    queryFn: async ({queryKey, signal}) => {
      const {params, token} = queryKey[1];
      return rqCreateRequest(
        RQ_GET_ENROLLMENT_BY_ID,
        null,
        token,
        params,
        signal,
        null,
      );
    },
    ...options,
  });
};

export const RQGetCustomerMasterReport = (payload, options={}) => {
  console.log(payload);
  return useQuery({
    queryKey: ['rq_search_customer_campaign_master', payload],
    queryFn: async ({queryKey, signal}) => {
      const {filter, token} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_SEARCH_CUSTOMER_CAMPAIGN_MASTER,
        null,
        token,
        null,
        signal,
        filter,
      );
    },
    ...options,
  });
};
